@if(isLoading()) {
  <ngx-skeleton-loader [theme]="{ height: '100%' }" />
} @else {
  <div class="flex flex-col h-full items-center justify-center">
    <p class="value text-ui-dark font-semibold text-3xl whitespace-nowrap text-ellipsis overflow-hidden">
      @if (datapoint().value !== null && datapoint().value !== undefined) {
        {{ datapoint().value! | avsFormatNumber: datapoint().unit?.displayShort }}
      } @else {
        No Data
      }
    </p>
    <p class="datapoint text-ui-gray-100 text-sm font-semibold break-words text-center overflow-hidden">
      {{ datapointName() }}
      @if (datapoint().date) {
        : {{ datapoint().date }}
      }
    </p>
  </div>
}
